(function () {
	'use strict';

	angular.module('mx.components').directive('mxRepeaterItem', mxRepeaterItem);

	function mxRepeaterItem() {
		return {
			restrict: 'A',
			bindToController: {
				item: '=mxRepeaterItem',
			},
			template: '',
			controller: function () {},
		};
	}
})();
